<template>
  <ul>
    <li
      v-for="paymentMethod in existingPaymentMethods"
      :key="paymentMethod.id"
      class="tw:flex tw:items-center tw:py-3"
      :class="{
        'tw:grayscale':
          (paymentMethod.type === 'CREDIT_CARD' && paymentMethod?.expired) || paymentMethod.type === 'WIRE_TRANSFER',
      }"
    >
      <input
        type="radio"
        name="paymentMethod"
        :disabled="
          (paymentMethod.type === 'CREDIT_CARD' && paymentMethod?.expired) || paymentMethod.type === 'WIRE_TRANSFER'
        "
        :value="paymentMethod.id"
        :id="paymentMethod.id"
        :checked="selectedPaymentMethod === paymentMethod.id"
        @change="emit('onChange', paymentMethod.id)"
        class="tw:cursor-pointer"
      />
      <label
        :for="paymentMethod.id"
        class="tw:cursor-pointer tw:m-0 tw:ml-3 tw:grow tw:flex tw:items-center tw:flex-wrap"
      >
        <div v-if="paymentMethod.type === 'SEPA'">
          <span class="tw:grow">{{
            `SEPA - ${paymentMethod.accountNumber} - ${paymentMethod.accountHolderInfo.accountHolderName}`
          }}</span>
        </div>
        <div v-else-if="paymentMethod.type === 'WIRE_TRANSFER'" class="tw:text-gray-300">
          <span class="tw:grow">{{ $t('rc_fop_bank_transfer') }}</span>
        </div>
        <div v-else-if="paymentMethod.type === 'CREDIT_CARD'" class="tw:flex tw:gap-x-2 tw:flex-wrap">
          <div>
            <img
              :src="getCreditCardLogoUrl(paymentMethod.creditCardType)"
              alt="Credit card logo"
              height="24"
              width="38"
              class="shadow-[0_0_1px_0_rgba(41,52,58,0.75)] tw:mr-2 tw:inline"
            />
            <span>{{
              $t('paymentMethods.paymentMethod.creditCard', {
                mask: paymentMethod.cardNumber,
                month: paymentMethod.expirationMonth,
                year: paymentMethod.expirationYear,
              })
            }}</span>
          </div>
        </div>
        <div v-else-if="paymentMethod.type === 'PAYPAL'" class="tw:flex tw:gap-x-2 tw:flex-wrap">
          <div>
            <img
              :src="paypalLogo"
              alt="PayPal logo"
              height="24"
              width="38"
              class="shadow-[0_0_1px_0_rgba(41,52,58,0.75)] tw:mr-2 tw:inline"
            />
            <span>PayPal - {{ paymentMethod.email }}</span>
          </div>
        </div>
      </label>
    </li>
  </ul>
</template>

<script setup>
const paypalLogo = new URL('/src/assets/img/settings-payment/paypal.png', import.meta.url)
const visaLogo = new URL('/src/assets/img/settings-payment/visa.png', import.meta.url)
const mastercardLogo = new URL('/src/assets/img/settings-payment/mastercard.png', import.meta.url)
const americanexpressLogo = new URL('/src/assets/img/settings-payment/americanexpress.png', import.meta.url)

defineProps({
  existingPaymentMethods: {
    type: Array,
    default: () => [],
  },
  selectedPaymentMethod: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['onChange'])

const getCreditCardLogoUrl = type => {
  if (type === 'Visa') return visaLogo
  if (type === 'MasterCard') return mastercardLogo
  if (type === 'AmericanExpress') return americanexpressLogo
}
</script>
